$(document).ready(function() {
  var array_cart_page_variant_id = [];
  $('.cart-item').each(function() {
    array_cart_page_variant_id.push($(this).attr('data-variant-id'));
  }).promise().done(function() {
    var requestData_cart_page = {
      variantIds: array_cart_page_variant_id
    };

    $.ajax({
      url: 'https://api.bombayhair.ca/uk/inventory-quantity/variant',
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(requestData_cart_page),
      success: function(response) {

        $('.cart-item').each(function() {
          var inven_test = $(this).attr('data-variant-id');
          
          // Check if response[inven_test] exists
          if (response[inven_test]) {
              var inven_qty_cart_page_item = response[inven_test].qty;     
              
              // Continue with your checks and DOM manipulation
            // we did not change currentproductidnumber id
              if (response[inven_test].productId !== '48892126167780000' && 
                  response[inven_test].productId !== '70238571725540000' && 
                  response[inven_test].productId !== '70238571070180000' &&
                  response[inven_test].productId !== '7919740420166' ) {
                if (inven_qty_cart_page_item <= 0) {             
                  $('<p class="ibat-cartpagebackorder">Backorder: Ships Once In Stock</p>')
                    .insertBefore($(this).children('.cart-item__details').children('.cart-item__quantity'));
                } else if (inven_qty_cart_page_item <= 4 && inven_qty_cart_page_item >= 1) {
                  $('<p class="ibat-cartpagebackorder">Less than 4 In Stock</p>')
                    .insertBefore($(this).children('.cart-item__details').children('.cart-item__quantity'));
                }
              }
          } else {
              console.error(`Invalid variant ID: ${inven_test}. Check response structure.`);
          }
        });
      },
      error: function(xhr, status, error) {
        console.error('Error:', error);
      }
    });
  });
});
